import { createContext, useContext, useState, useCallback, useMemo } from "react";

const DrawerContext = createContext(null);

export const DrawerProvider = ({ children }) => {
    const [drawerSidePanel, setDrawerSidePanel] = useState(null);
    const [isShowDrawerPanel, setShowDrawerPanel] = useState(false);
    const [isDrawerOpen, setDrawerOpen] = useState(false);

    const toggleDrawerPanel = useCallback(() => setDrawerOpen((prev) => !prev), []);

    const registerDrawerSidePanel = useCallback(({ defaultOpen = false } = {}) => {
        setShowDrawerPanel(true);
        setDrawerOpen(defaultOpen);
    }, []);

    const unRegisterDrawerSidePanel = useCallback(() => {
        setShowDrawerPanel(false);
        setDrawerOpen(false);
    }, []);

    const value = useMemo(
        () => ({ drawerSidePanel, setDrawerSidePanel, isShowDrawerPanel, isDrawerOpen, toggleDrawerPanel, registerDrawerSidePanel, unRegisterDrawerSidePanel }),
        [drawerSidePanel, isShowDrawerPanel, isDrawerOpen, toggleDrawerPanel, registerDrawerSidePanel, unRegisterDrawerSidePanel]
    );

    return <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>;
};

export const useDrawerContext = () => {
    const context = useContext(DrawerContext);

    if (!context) {
        throw new Error("useDrawerContext must be used within DrawerProvider");
    }

    return context;
};
